import { LabeledValue } from "@msys/ui";
import { Box, Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { useCategories } from "./useCategories.js";

interface Props {
  categoryId: string | null;
  label?: string;
  leftIcon?: React.ReactNode;
  rightButton?: React.ReactNode;
  required?: boolean;
}

export const CategoryLabeledValue = ({
  categoryId,
  label,
  leftIcon,
  rightButton,
  required = false,
}: Props) => {
  const { t } = useTranslate(["Categories", "Global"]);
  const { getCategories, loading } = useCategories();
  const category = categoryId
    ? (getCategories({
        addParentsWhenNotIncluded: false,
        removeChildrenIfIncluded: false,
      }).find(c => c.id === categoryId) ?? null)
    : null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      width="100%"
    >
      <Stack
        direction="row"
        alignItems="center"
        minWidth={0}
        spacing={1}
        flex={1}
      >
        <LabeledValue
          label={
            label ??
            t("Category", { ns: "Categories" }) + (required ? " *" : "")
          }
        >
          {loading ? "" : category?.name || "–"}
        </LabeledValue>
        {leftIcon}
      </Stack>
      {rightButton ? <Box display="flex">{rightButton}</Box> : null}
    </Stack>
  );
};
